// extracted by mini-css-extract-plugin
export default {"labelText":"DashboardDrawer_labelText__YLKSE"};